import { requestWithToken } from '../utilities/request';

const path = '/api/private/kmobiles';

const bulkUpdate = params => {
  return requestWithToken(
    {
      method: 'POST',
      url: `${path}/kmobile_state_managements/bulk_update`,
      data: params,
    },
    false
  );
};

export const KmobileService = {
  bulkUpdate,
};

export default KmobileService;



// WEBPACK FOOTER //
// ./src/services/Kmobile.js